import React from "react";
import withStyles from "react-jss";
import Price from "../components/Price";

const styles = (theme) => ({
	root: {},
	arrow: {
		margin: "5px auto 10px",
		width: "24px",
		"& span": {
			fontSize: "24px",
			color: "#d3cee1",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			display: "none",
		},
	},
});

const Component = ({ classes, text, valueBefore, valueAfter }) => (
	<div className={classes.root}>
		<Price text={text} value={valueBefore} measureText={text.SUBSCRIPTION_FEE_TITLE_} green />
		<div className={classes.arrow}>
			<span className="icon24 icon-arrow-2-down" />
		</div>
		<Price value={valueAfter} text={text} />
	</div>
);

const PriceWithChangeLayout = withStyles(styles)(Component);
PriceWithChangeLayout.displayName = "PriceWithChangeLayout";

export default PriceWithChangeLayout;
